module.exports = "/images/vendor/flag-icon-css/flags/1x1/gb-wls.svg?85f8b84246b2d0b3b65de2d5d34f5ffe";